module.exports = __webpack_public_path__ + "img/add-answer.df3f5103.png";